<template>
  <div class="member-wrapper">
    <div class='content'>
      <van-radio-group v-model="verifyWay" class='radio-reset'>
        <van-radio :name="1">手机验证</van-radio>
        <van-radio :name="2">邮箱验证</van-radio>
      </van-radio-group>
      <van-cell-group>
        <van-field v-validate="rules.oldAccount" v-model.trim="oldAccount" name="oldAccount" :error-message="errors.first('oldAccount')" :placeholder="verifyWay==1?'请输入旧手机号':'请输入旧邮箱'" disabled required />
        <van-field v-model.trim="oldCode" v-validate="rules.oldCode" placeholder="请输入验证码" :error-message="errors.first('oldCode')" name="oldCode" required>
          <vericode slot='button' :send-code='sendOldCode' :disable='oldDisable' @send-code='handleSendOldCode'></vericode>
        </van-field>
        <van-field v-validate="rules.newAccount" v-model.trim="newAccount" name="newAccount" @input='handleNewInput' :error-message="errors.first('newAccount')" placeholder="请输入新手机号" required />
        <van-field v-model.trim="newCode" v-validate="rules.newCode" placeholder="请输入验证码" :error-message="errors.first('newCode')" name="newCode" required>
          <vericode slot='button' :send-code='sendNewCode' :disable='newDisable' @send-code='handleSendNewCode'></vericode>
        </van-field>
      </van-cell-group>
      <div class='common-btn-wrap'>
        <van-button type="info" :disabled='saveDisabled' size="large" @click="confirmSubmit">确定</van-button>
      </div>
    </div>
  </div>
</template>
<script>
import Vericode from "@/components/member/vericode";
import { Toast } from 'vant';
const mobileReg = /^(\d{3})\d{4}(\d{4})$/
export default {
  components: {
    Vericode
  },
  data () {
    return {
      verifyWay: 1,
      oldDisable: false,
      newDisable: true,
      sendOldCode: false,
      sendNewCode: false,
      saveDisabled: false,
      sendCodeDisabled: false,
      oldAccount: '',
      newAccount: '',
      oldCode: '',
      newCode: '',
      disable: true,
      sendCode: false,
      sOldCode: false,
      sNewCode: false,
      rules: {
        oldAccount: { required: true, formatOldAccount: true },
        newAccount: { required: true, formatNewAccount: true },
        oldCode: { required: true },
        newCode: { required: true }
      }
    }
  },
  watch: {
    sOldCode: {
      handler (val, oldVal) {
        this.sendOldCode = val
      }
    },
    sNewCode: {
      handler (val, oldVal) {
        this.sendNewCode = val
      }
    },
    verifyWay: {
      immediate: true,
      deep: true,
      handler: function (val) {
        if (val == 2 && !this.$store.getters.user.Email.length) {
          Toast.loading({
            duration: 1000,
            message: '账号无绑定邮箱，不支持验证修改邮箱...',
            overlay: true
          })
          this.verifyWay = 1
          return
        }
        if (val == 1 && !this.$store.getters.user.Mobile.length) {
          Toast.loading({
            duration: 1000,
            message: '账号无绑定手机号，不支持验证修改手机号...',
            overlay: true
          })
          this.verifyWay = 2
          return
        }
        this.oldAccount = val == 1 ? this.$store.getters.user.Mobile.replace(mobileReg, "$1****$2") : this.$store.getters.user.Email
        this.oldCode = ''
        this.sOldCode = false
        this.oldDisable = false
        this.newAccount = ''
        this.newCode = ''
        this.sNewCode = false
        this.newDisable = true
      },
    }
  },
  methods: {
    handleNewInput (val) {
      this.$validator.validate('newAccount').then(result => {
        if (result) {
          this.newAccount = val
          this.newDisable = false
        } else {
          this.newDisable = true
        }
      })
    },
    handleSendOldCode () {
      this.sOldCode = true
      let params = {
        AppID: this.GLOBAL.AppID,//应用号:3:Erp2,12:在线提交3
        Method: 'GetVerifyCodeNew',
        Account: this.verifyWay == 1 ? this.$store.getters.user.Mobile : this.$store.getters.user.Email,//帐号:maxlength:100
        Type: 4//验证码类型:1:注册,2:需要登录修改密码,3:无需登录修改密码,4:修改用户帐号 
      }
      this.$Request(params).then(res => {
      }).catch(() => {
      })
    },
    handleSendNewCode () {
      this.sNewCode = true
      let params = {
        AppID: this.GLOBAL.AppID,//应用号:3:Erp2,12:在线提交3
        Method: 'GetVerifyCodeNew',
        Account: this.newAccount,//帐号:maxlength:100
        Type: 4//验证码类型:1:注册,2:需要登录修改密码,3:无需登录修改密码,4:修改用户帐号 
      }
      this.$Request(params).then(res => {
      }).catch(() => {
      })
    },
    //确定
    confirmSubmit () {
      this.$validator.validateAll().then(result => {
        if (result) {
          Toast.loading({
            duration: 0,
            message: '正在保存...',
            overlay: true
          });
          this.saveDisabled = true;
          this.$Request({
            AppID: this.GLOBAL.AppID,
            Method: 'UpdateAccountV3',
            OldAccount: this.verifyWay == 1 ? this.$store.getters.user.Mobile : this.$store.getters.user.Email,//旧帐号:maxlength:100
            NewAccount: this.newAccount,//新帐号:maxlength:100
            OldCode: this.oldCode,//旧账号验证码:maxlength:6
            NewCode: this.newCode,//新账号验证码:maxlength:6 
          }).then(res => {
            Toast.clear();
            Toast.success({
              duration: 1000,
              message: '修改成功,请重新登陆'
            })
            setTimeout(() => {
              this.saveDisabled = false;
              this.$store.dispatch('FedLogOut').then(() => {
                this.$router.push({ path: '/signIn' });
              })
            }, 1000)
          }, err => {
            setTimeout(() => {
              Toast.clear();
              this.saveDisabled = false;
            }, 3000)
          })
        }

      })
    },
    //验证
    validateField () {
      this.$validator.extend('formatOldAccount', {
        getMessage: field => this.verifyWay == 1 ? "请输入正确格式的手机号" : "请输入正确格式的邮箱",
        validate: (value) => {
          return this.verifyWay == 1 ? /^1\d{10}$/.test(value) || /^1\d{2}\*{4}\d{4}$/.test(value) : /^[a-zA-Z0-9_-]+@[a-zA-Z0-9_-]+(\.[a-z0-9_-]+)+$/.test(value)
        }
      });
      this.$validator.extend('formatNewAccount', {
        getMessage: field => "请输入正确格式的手机号",
        validate: (value) => {
          return /^1\d{10}$/.test(value) || /^1\d{2}\*{4}\d{4}$/.test(value)
        }
      });
    },
  },
  created () {
    this.validateField();
  }
}
</script>
<style lang="less" scoped>
.content {
  padding: 20px 0;
  .btn-wrap {
    width: 80%;
    text-align: center;
    margin: 100px auto;
  }
  .error-tip {
    color: @red;
    padding-left: 200px;
  }
}
.van-hairline--top-bottom::after {
  border-width: 0;
}
.common-btn-wrap {
  position: absolute;
  bottom: 200px;
}
.radio-reset {
  display: flex;
  .van-radio {
    margin: 10px 20px;
  }
}
</style>


// WEBPACK FOOTER //
// src/views/member/edit-phone.vue